import IndexComponent from './component';

function Index() {
  return <IndexComponent />;
}

export default Index;
